function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * List of helper methods related to the Sitecore rendering
 */
var WDHSitecoreHelper = /*#__PURE__*/function () {
  function WDHSitecoreHelper() {
    _classCallCheck(this, WDHSitecoreHelper);
  }

  _createClass(WDHSitecoreHelper, null, [{
    key: "fixRTESpanLinks",
    value:
    /**
     * Changes any <span class="some-class"><a /></span> to <span><a class="some-class" /></span>
     * @param Strig[] classList List of classes to fix
     */
    function fixRTESpanLinks(classList) {
      classList.forEach(function (className) {
        var aList = document.querySelectorAll("span.".concat(className, ">a"));
        aList.forEach(function (aTag) {
          var spanTag = aTag.parentNode;
          WDHSitecoreHelper.switchClass(className, spanTag, aTag);
        });
        var spanList = document.querySelectorAll("a>span.".concat(className));
        spanList.forEach(function (spanTag) {
          var aTag = spanTag.parentNode;
          WDHSitecoreHelper.switchClass(className, spanTag, aTag);
        });
      });
    }
    /**
     * Removes className from one element and adds it to another
     * @param className
     * @param elementToRemoveFrom
     * @param elementToAddTo
     * @private
     */

  }, {
    key: "switchClass",
    value: function switchClass(className, elementToRemoveFrom, elementToAddTo) {
      elementToRemoveFrom.classList.remove(className);
      elementToAddTo.classList.add(className);
    }
  }]);

  return WDHSitecoreHelper;
}();

export default WDHSitecoreHelper;